import React, { Component } from "react";
import PropTypes from "prop-types";
import { MenuItem, Select } from "@mui/material";
import { MassUnit } from "../../models/features/Product/Product";

interface MassUnitListProps {
  onChange: any;
  value: any;
  name?: string;
  id?: string;
}

const MassUnitList: React.FunctionComponent<MassUnitListProps> = ({
  onChange,
  value,
  id,
  name,
}) => {
  return (
    <Select
      name={name ?? ""}
      id={id ?? ""}
      value={
        value == "Gram"
          ? 0
          : value == "Kilogram"
          ? 1
          : value == "Pound"
          ? 2
          : value
      }
      onChange={onChange}
      variant={"standard"}
    >
      {/* <MenuItem value="">
        <em>None</em>
      </MenuItem> */}
      {MassUnit.map((item) => (
        <MenuItem value={item.value}>{item.title}</MenuItem>
      ))}
    </Select>
  );
};

export default MassUnitList;
